import ListProgram from './Main'

const route = {
  path: '/archive/program',
  name: 'programArchive',
  meta: {
    title: 'Archive - A D M A N 2 0 1 9'
  },
  component: ListProgram
}

export default route
